module.exports = __webpack_public_path__ + "static/media/painel_licitacao.ab49b970.png";